import { EmojiWithBackground } from '$tablet-app/src/app/components/EmojiWithBackground/EmojiWithBackground';
import Text from '$tablet-app/src/app/components/Text';
import { Alarm, Alert, Event } from '$tablet-app/src/app/models';
import { getStartDate } from '@akin-home/calendar';
import { spacing } from '@akin-home/theme';
import { format } from 'date-fns';
import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import styled from 'styled-components/native';
import { ItemStyling } from './types';

interface Props {
  item: Alert | Event | Alarm;
  styling: ItemStyling;
}

/** Item to be displayed in the breakdown schedule */
const EventScheduleItemContent: FC<Props> = (props) => {
  const { item, styling } = props;

  return (
    <View style={styles.container}>
      {item.emoji ? (
        <View style={styling.imageContainerStyle}>
          <Emoji
            size={styling.emojiSize}
            emoji={item.emoji}
            emojiStyle={{ fontSize: styling.emojiSize / 2.4 }}
          />
        </View>
      ) : null}

      <View style={[styles.contentContainer, styling.contentContainerStyle]}>
        <View style={styles.textContainer}>
          <Text
            variant={styling.titleTextVariant}
            weight="semibold"
            numberOfLines={2}
            style={[styles.titleText, styling.titleTextStyle]}
          >
            {item.title}
          </Text>

          <Text variant={styling.subtitleTextVariant}>
            {format(getStartDate(item), 'h:mm a')}
          </Text>
        </View>

        {/* Commented this as, at the time of writing, participants are never used and so its not considered in small screen design */}
        {/* {'participants' in item && item.participants ? (
          <View>
            <ProfileIcons profiles={item.participants} preset="overlapRight" />
          </View>
        ) : null} */}
      </View>
    </View>
  );
};

const Emoji = styled(EmojiWithBackground)<{ size?: number }>`
  width: ${({ size = 66 }) => size}px;
  height: ${({ size = 66 }) => size}px;
`;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing[4],
  },
  contentContainer: {
    flex: 1,
    gap: spacing[2],
  },
  textContainer: {
    flex: 1,
  },
  titleText: {
    overflow: 'hidden',
  },
  mealChipContainer: {
    alignSelf: 'flex-start',
  },
});

export default EventScheduleItemContent;
